import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import {
  clearStoredSession,
  getStoredAccessToken,
  hasValidStoredSession,
  isTokenExpired,
  readStoredUserInfo,
} from "./hooks/authSession";

function ProtectedRouter() {
  const userInfo = readStoredUserInfo();
  const accessToken = getStoredAccessToken(userInfo);

  try {
    if (!hasValidStoredSession(userInfo)) {
      console.warn("Session expired or missing. Logging out.");
      clearStoredSession();
      return <Navigate to="/login" replace />;
    }

    if (isTokenExpired(accessToken)) {
      clearStoredSession();
      return <Navigate to="/login" replace />;
    }
  } catch (err) {
    console.error("Auth check failed:", err);
    clearStoredSession();
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export { ProtectedRouter };
